import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Tab } from './tab';
import { filterOnlyTabs, getActiveId } from './tabs-utils';
import type { TabsProps } from './tabs.types';
import { OEText } from '../../atoms/oe-text/oe-text';

export const Tabs = ({
  activeId,
  defaultActiveId,
  onChange,
  children,
}: TabsProps) => {
  const tabs = filterOnlyTabs(children);
  const tabsIds = tabs.map((tab) => tab.props.id);

  const [internalActiveId, setInternalActiveId] = useState(() =>
    getActiveId(activeId, defaultActiveId, tabsIds)
  );

  const selectedTab = tabs.find((tab) => tab.props.id === internalActiveId);

  useEffect(() => {
    if (activeId) {
      setInternalActiveId(getActiveId(activeId, undefined, tabsIds));
    }
  }, [activeId, tabsIds]);

  const onTabClick = (id: React.Key | null) => {
    const isActiveChanged = id !== internalActiveId;
    if (isActiveChanged && id) {
      // When activeId !== undefined, then the parent component is responsable of handling the active tab
      if (activeId !== undefined) {
        onChange?.(id);
      } else {
        setInternalActiveId(id);
      }
    }
  };

  return (
    <View>
      <HeaderContainer>
        {tabs.map((tab) => {
          const isActive = internalActiveId === tab.props.id;

          return (
            <TabItem
              key={tab.props.id}
              onPress={() => onTabClick(tab.props.id)}
            >
              <Title fontType={isActive ? 'semiBold' : 'regular'}>
                {tab.props.title}
              </Title>
              {isActive && <SelectedIndicator />}
            </TabItem>
          );
        })}
      </HeaderContainer>
      {selectedTab}
    </View>
  );
};

Tabs.Tab = Tab;

const HeaderContainer = styled.View`
  flex-direction: row;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.lightPrimary};
`;

const TabItem = styled.Pressable`
  padding: 4px 24px;
  margin-right: 8px;
`;

const SelectedIndicator = styled.View`
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.color.primary};
  border-radius: 4px;
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
`;

const Title = styled(OEText).attrs(({ theme }) => ({
  fontFamily: secondaryFontFamily,
  color: theme.color.dark1,
}))``;
